export default __webpack_public_path__ + "static/media/mainlogo.14719bf7.svg";